import filterParagraphFilter from 'common/filters/filterParagraphFilter'
import filterRemoveEmailSitePhone from 'common/filters/filterRemoveEmailSitePhone'

/**
 * Готовит HTML текстовых блоков секции «Информация».
 *
 * Делит текст по переводам строк на абзацы, как `paragraph_filter`.
 * Для описания и услуг дополнительно вырезает email, сайт и телефон.
 */
export default function getInformationHtml(
  text: string | null | undefined,
  {
    stripContacts = false,
    allowedHosts = [],
  }: {
    stripContacts?: boolean
    allowedHosts?: string[]
  } = {},
) {
  if (!text) {
    return ''
  }

  const prepared = stripContacts
    ? filterRemoveEmailSitePhone(text, '', allowedHosts)
    : text

  return filterParagraphFilter(prepared)
}
